import {common_utils} from "../common/common_utils";
function game_1001()
{

}
game_1001.read_odd = function(id)
{
    if(id === 1)
    {
      return "15";
    }
    else if(id === 2)
    {
      return "3";
    }
    else if(id === 3)  {
      return "12";
    }
    else if(id === 4)  {
      return "20";
    }
    else if(id === 5){
      return "25";
    }
    else if(id === 6){
      return "9";
    }
    else if(id === 7){
      return "40";
    }
    else if(id === 8){
      return "3";
    }
    else if(id === 9){
      return "10";
    }
    else if(id === 10){
      return "5";
    }
    else if(id === 11){
      return "2";
    }
    else if(id === 12){
      return "18";
    }
    else if(id === 13){
      return "4";
    }
    else if(id === 14){
      return "8";
    }
    else if(id === 15){
      return "7";
    }
    else if(id === 16){
      return "6";
    }
    else if(id === 17){
      return "50";
    }
    else if(id === 18){
      return "100";
    }
    else if(id === 19){
      return "30";
    }
    else if(id === 26)  {
      return "2";
    }
    else if(id === 27)  {
      return "3";
    }
    else if(id === 28)  {
      return "3";
    }
    else if(id === 29){
      return  "4";
    }
    else if(id === 30){
      return  "5";
    }
    else if(id === 31){
      return  "6";
    }
    else if(id === 32){
      return  "7";
    }
    else if(id === 33){
      return  "8";
    }
    else if(id === 34){
      return  "9";
    }
    else if(id === 35){
      return  "10";
    }
    else if(id === 36){
      return  "12";
    }
    else if(id === 37){
      return  "15";
    }
    else if(id === 38){
      return  "18";
    }
    else if(id === 39){
      return  "20";
    }
    else if(id === 40){
      return  "25";
    }
    else if(id === 41){
      return  "30";
    }
    else if(id === 42){
      return  "40";
    }
    else if(id === 43){
      return  "50";
    }
    else if(id === 46){
      return  "80";
    }
    else if(id === 47){
      return  "60";
    }
    else if(id === 48){
      return  "120";
    }
    else if(id === 49){
      return  "100-300";
    }
    else if(id === 50){
      return  "100";
    }
    else if(id === 51){
      return  "10";
    }
    else if(id === 52){
      return  "10";
    }

}

export {
  game_1001
};



// WEBPACK FOOTER //
// ./src/components/fish/game_1001.js